export enum AgentAssignmentFilterEnum {
  Unassigned = "unassigned",
  Assigned = "assigned",
}

export const AgentAssignmentFilterEnumMap = {
  fromQueryString: {
    false: AgentAssignmentFilterEnum.Unassigned,
    true: AgentAssignmentFilterEnum.Assigned,
  },
  toQueryString: {
    [AgentAssignmentFilterEnum.Unassigned]: false,
    [AgentAssignmentFilterEnum.Assigned]: true,
  },
};
